var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgArrowUp = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 7,
    viewBox: "0 0 10 7",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.18555 0.205078L9.16992 4.18945C9.30664 4.32617 9.375 4.49219 9.375 4.6875C9.375 4.88281 9.30664 5.04883 9.16992 5.18555L8.49609 5.83008C8.35937 5.9668 8.19336 6.03516 7.99805 6.03516C7.80273 6.03516 7.63672 5.9668 7.5 5.83008L4.6875 3.01758L1.875 5.83008C1.73828 5.9668 1.57227 6.03516 1.37695 6.03516C1.18164 6.03516 1.01562 5.9668 0.878906 5.83008L0.205078 5.18555C0.0683593 5.04883 -1.00741e-07 4.88281 -1.17816e-07 4.6875C-1.34891e-07 4.49219 0.0683592 4.32617 0.205078 4.18945L4.18945 0.205079C4.32617 0.0683598 4.49219 4.26869e-07 4.6875 4.09794e-07C4.88281 3.9272e-07 5.04883 0.0683598 5.18555 0.205078Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgArrowUp, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/arrowUp.e9743bb2.svg";
export { ForwardRef as ReactComponent };